import api from '@/services/gateway/api';

const baseUrl = 'camp/sales/cities';

const withNumericIsActive = (payload) => {
  if (!payload || payload.is_active === undefined || payload.is_active === null) {
    return payload;
  }
  return Object.assign({}, payload, { is_active: payload.is_active ? 1 : 0 });
};

const state = {
  list: [],
  item: {}
};

const getters = {
  getList: (state) => state.list,
  getItem: (state) => state.item
};

const mutations = {
  setList (state, data) {
    state.list = data;
  },
  setItem (state, data) {
    state.item = data;
  }
};

const actions = {
  getList ({ commit }, payload) {
    return api.get(baseUrl, { params: withNumericIsActive(payload) })
      .then((response) => {
        commit('setList', response.data.data);
        return response.data.data;
      });
  },
  getItem ({ commit }, payload) {
    return api.get(baseUrl)
      .then((response) => {
        const id = Number(payload);
        const city = (response.data.data || []).find((c) => Number(c.id) === id);
        if (!city) {
          const error = new Error('Request failed with status code 404');
          error.response = { status: 404 };
          throw error;
        }
        commit('setItem', city);
        return city;
      });
  },
  addItem ({ commit }, payload) {
    return api.post(baseUrl, withNumericIsActive(payload));
  },
  editItem ({ commit }, payload) {
    const body = withNumericIsActive(payload);
    body['_method'] = 'PUT';
    return api.post(baseUrl + '/' + payload.id, body);
  },
  toggleVisibility ({ commit }, payload) {
    return api.post(baseUrl + '/' + payload.id + '/visibility', {
      is_active: payload.is_active ? 1 : 0,
      _method: 'PATCH'
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
